module.exports = __webpack_public_path__ + "static/media/school-portal-msf-banner.3fec25e4.png";